import React from 'react'
import PropTypes from 'prop-types'
import MaskedInput from 'react-text-mask'


import Template01 from '../images/templates/template-arrendamiento.jpg'
import Template02 from '../images/templates/template-compraventa-automovil.jpg'

function TemplateCard(props) {
  return (
   <section className="py-5">
       <div className="container">
       <div className="row">
           <div className="col-md-4">
                <div className="card">
                    <div className="card-header p-0">
                        <img src={Template01} className="img-fluid rounded-top" />
                    </div>
                    <div className="card-body">
                        <div className="mb-2">
                        <small><span className="badge btn-accent">Gratuita</span></small> <small><span className="badge bg-grey border">México</span></small>
                        </div>
                        <h6 className="font-weight-bold mb-1">Plantilla de arrendamiento</h6>
                        <small className="d-block text-muted">Arrendamiento de bien Inmueble (vivienda/negocio) sin Fiador (llenado de variables por ambas partes).</small>
                    </div>
                    <div className="card-footer bg-light text-center">
                        <button className="btn btn-default btn-sm mx-2">Vista previa</button>
                        <button className="btn btn-accent-100 btn-sm text-light mx-2">Usar ahora</button>
                    </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card">
                    <div className="card-header p-0">
                        <img src={Template02} className="img-fluid rounded-top" />
                    </div>
                    <div className="card-body">
                        <div className="mb-2">
                        <small><span className="badge btn-accent">Gratuita</span></small> <small><span className="badge bg-grey border">México</span></small>
                        </div>
                        <h6 className="font-weight-bold mb-1">Contrato compraventa automóvil</h6>
                        <small className="d-block text-muted">Compra Venta de auto usado y ilberación de responsabilidad (llenado por ambas partes).</small>
                    </div>
                    <div className="card-footer bg-light text-center">
                        <button className="btn btn-default btn-sm mx-2">Vista previa</button>
                        <button className="btn btn-accent-100 btn-sm text-light mx-2">Usar ahora</button>
                    </div>
                </div>
            </div>
       </div>
       </div>
   </section>
  )
}


export default TemplateCard

